import React from 'react';
import PropTypes from 'prop-types';

import styles from './BasicInput.css';

const IPropTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

const defaultProps = {
  className: '',
  error: null,
};

const BasicInput = (props) => {
  const propsToPass = { ...props };
  delete propsToPass.className;
  delete propsToPass.id;
  return (
    <div className={props.className}>
      {
        !!props.label &&
        <label
          className={styles.label}
          htmlFor={props.name}
        >
          {props.label}
        </label>
      }
      <input
        className={styles.input}
        id={props.name}
        {...propsToPass}
      />
      {
        !!props.error &&
        <p className={styles.error}>
          {props.error}
        </p>
      }
    </div>
  );
};

BasicInput.propTypes = IPropTypes;
BasicInput.defaultProps = defaultProps;

export { BasicInput };



// WEBPACK FOOTER //
// ./src/common/basic-input/BasicInput.jsx